"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgZipPay = function SvgZipPay(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    fill: "none",
    viewBox: "0 0 112 32"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#clip0)",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#1A0826",
        d: "M1.96 25.784L2.72 32h26.6l-.87-7.119H16.047L15.94 24l11.423-8.016-.763-6.228H0l.87 7.118h12.423l.11.89L1.96 25.785z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#AA8FFF",
        d: "M29.756 9.755L32.476 32h51.577L81.332 9.755H29.756z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#1A0826",
        d: "M111.903 17.77c-.614-5-4.526-8.031-9.842-8.01H84.355l2.72 22.246h7.965l-.545-4.45h8.43c6.635-.006 9.671-4.157 8.978-9.787zm-9.839 3.55l-8.328.01-.651-5.339 8.374.007c1.97.023 2.977 1.138 3.139 2.662.102.973-.347 2.654-2.534 2.654v.007zM36.29 7.633c1.401-1.51 1.157-4.026-.545-5.618-1.703-1.592-4.218-1.659-5.62-.148-1.4 1.51-1.156 4.025.546 5.617 1.702 1.593 4.218 1.66 5.62.149zM41.602 24.377l.369 3.024H37.45l-1.544-12.61h7.451c5.22 0 7.53 1.636 7.935 4.906.382 3.13-1.736 4.697-6.59 4.676l-3.1.004zm-.748-6.118l.342 2.83h2.95c2.018 0 2.654-.351 2.529-1.374-.148-1.214-.993-1.46-2.933-1.46l-2.888.004zM61.416 25.24h-5.407l-.608 2.164h-4.335l4.021-12.602h4.705l7.067 12.602h-4.294l-1.15-2.163zm-3.537-6.663l-1.04 3.675h2.994l-1.954-3.675zM69.577 27.404l-.612-5.01-6.167-7.596h4.762l3.24 4.132 2.353-4.132h4.744l-4.57 7.613.61 4.994-4.36-.001z"
      })]
    }), (0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0",
        children: (0, _jsxRuntime.jsx)("path", {
          fill: "#fff",
          d: "M0 0H112V32H0z"
        })
      })
    })]
  }));
};

var _default = SvgZipPay;
exports["default"] = _default;